<svelte:options tag="ripe-header" />

<div id="ripe-header">
  <div id="menu-container">
    {#if !hidemenu}
      <div id="burger-menu">
        <button
          on:click={toggleMenu}
          on:touchstart={toggleMenu}
          class:active={open}
          class:light-theme={lighttheme}
          aria-label="menu-button"
        >
          <span />
        </button>
      </div>
    {:else}
      <div id="burger-menu-hidden" />
    {/if}
    <a href="/" aria-label="go-home-link">
      <div id="logo-container">
        {#if splitlogo}
          <slot name="logo-app-icon">
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="-10 -10 215 215"
              height="51px"
              style="padding-top: 0.35rem;"
              aria-label="RIPE NCC logo"
            >
              <defs>
                <linearGradient
                  id="linear-gradient"
                  x1="87.89"
                  y1="378.84"
                  x2="211.27"
                  y2="255.46"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" stop-color="#25316a" />
                  <stop offset="0.07" stop-color="#293269" />
                  <stop offset="0.14" stop-color="#353664" />
                  <stop offset="0.2" stop-color="#493b5d" />
                  <stop offset="0.27" stop-color="#664453" />
                  <stop offset="0.34" stop-color="#8a4e46" />
                  <stop offset="0.41" stop-color="#b75b36" />
                  <stop offset="0.48" stop-color="#eb6a24" />
                  <stop offset="0.49" stop-color="#f36c21" />
                  <stop offset="1" stop-color="#9c9c9c" />
                </linearGradient>
              </defs>
              <g class:spinning={spinningState} class="logo-icon">
                <path
                  d="M192.86,283.67V237.05l-43.28-25-43.28,25v46.62L66,307v50l43.28,25,40.32-23.29,40.33,23.29,43.28-25V307Zm-43.28,21.52-34.42-19.87,34.42-19.87L184,285.32Zm-37.37-14.7,34.42,19.87v39.69l-34.42-19.87Zm40.32,19.87L187,290.49v39.69l-34.42,19.87Zm-40.32-69.9,37.37-21.58L187,240.46V280.2l-37.37-21.57L112.21,280.2ZM71.88,353.52V310.36l34.42-19.87v43.1l37.42,21.6-34.46,19.9Zm155.4,0-37.37,21.57-34.47-19.9,37.42-21.6v-43.1l34.42,19.87Z"
                  transform="translate(-65.98 -212.06)"
                  style="fill: url(#linear-gradient)"
                />
              </g>
            </svg>
          </slot>
          <slot name="logo-app-title" />
        {:else}
          <slot name="logo-app" />
        {/if}
      </div>
    </a>
  </div>

  <div id="actions-container">
    <slot />
  </div>
</div>

<script>
  import { get_current_component } from 'svelte/internal'

  export let open
  export let hidemenu = false
  export let spinning
  export let showquestionmark
  export let lighttheme
  export let splitlogo
  let spinningState = false
  let startSpinTime

  const component = get_current_component()

  // Sets the Button to X or ===
  // html attributes will be passed as an empty string,
  // which evaluates to false in JS, so check for 'truthy' + ""
  $: open = open || open === ''
  // $: accessPictureUrl = `${accessLoginUrl}/picture/${user.uuid}`
  // $: userLoggedIn = userLoggedIn
  $: lighttheme = lighttheme || lighttheme === ''
  $: spinningState = spinningState
  // I don't know, but svelte insists on parsing `bare` html attributes
  // as having as a value an empty string (I think it conveys the
  // value `true` and so does https://html.spec.whatwg.org/multipage/common-microsyntaxes.html#boolean-attributes),
  // but hey.
  // Sooooo, we're parsing empty string as `true` or use the value it already has,
  // or set it to false.
  $: {
    splitlogo = (splitlogo === '' && true) || splitlogo || false
    spinning = (spinning === '' && true) || spinning || false
    if (!spinning && startSpinTime) {
      const td = 700 - ((new Date() - startSpinTime) % 700) + 300
      window.setTimeout(() => {
        spinningState = false
      }, td)
    }
    if (spinning) {
      spinningState = true
    }
    startSpinTime = new Date()
  }
  $: showquestionmark = showquestionmark === '' && true

  const toggleMenu = e => {
    e.preventDefault()
    open = !open

    const event = new CustomEvent('ripe-header-menu-toggle', {
      detail: {
        open: open,
      },
      bubbles: true,
      cancelable: true,
      composed: true,
    })
    component.dispatchEvent(event)
  }
</script>

<style type="text/scss">
  $header-padding: 1.4rem;
  @mixin flex-c {
    display: flex;
    align-items: center;
  }

  :host {
    position: sticky;
    top: 0;
    z-index: 99999;
    display: flex;
    width: 100%;
    min-width: 100vw;
    max-width: 100vw;
    height: 70px;
    user-select: none;
  }
  #ripe-header {
    @include flex-c;
    justify-content: space-between;
    background: #fff;
    width: 100%;
    height: 70px;
    box-shadow: 0 0 9px rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    padding-top: var(--ripe-header-padding-top, 0px);
    @media print {
      position: static;
    }

    #menu-container {
      @include flex-c;
      height: 100%;
    }

    #burger-menu-hidden {
      width: $header-padding;
    }

    #burger-menu {
      @include flex-c;
      justify-content: center;
      margin-right: 1rem;
      height: 100%;
      width: 70px;
      min-width: 70px;
      @media print {
        display: none;
      }
      button {
        display: inline-block;
        width: 100%;
        height: 100%;
        padding: 0;
        cursor: pointer;
        transition: background 0.2s ease-in-out;
        vertical-align: middle;
        border: 0 none;
        background: var(--ripe-app-navbar-background, #080037);
      }
      button.light-theme {
        background: var(--ripe-app-primary-20, white);
      }
      button:before,
      button:after {
        content: '';
      }

      button.light-theme:before,
      button.light-theme span,
      button.light-theme:after {
        background: var(--ripe-app-primary-100, black);
      }

      button:before,
      button span,
      button:after {
        width: 40%;
        display: block;
        height: 3px;
        margin: 0 auto 3px auto;
        transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out, background 0.2s ease-in-out;
        border-radius: 0.05em;
        background: #fff;
      }

      button.active span {
        opacity: 0;
      }
      button.active:before {
        transform: translateY(6px) rotate(135deg);
      }
      button.active:after {
        transform: translateY(-6px) rotate(-135deg);
      }
      button:focus {
        outline: 0;
      }
    }
    @keyframes backhoming {
      from {
        transform: scale(1);
      }
      to {
        // transform: rotate(0deg);
        transform: scale(10);
      }
    }
    @keyframes rotating {
      0% {
        transform: rotate(0deg);
      }

      33.33% {
        transform: rotate(120deg);
      }

      66.66% {
        transform: rotate(240deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
    #logo-container {
      @include flex-c;
      height: 51px;
    }

    .logo-icon {
      transform-origin: 40% 45.7%;
    }

    .logo-icon.spinning {
      animation: 2.1s ease-in-out 0.3s infinite forwards running rotating;
    }
    #actions-container {
      @include flex-c;
      height: 100%;
      padding: 0 $header-padding 0 0;
    }
  }
  @media only screen and (max-width: 400px) {
    ::slotted(svg) {
      max-width: 100px;
    }
    #actions-container {
      justify-content: flex-start;
      & > svg {
        transform: scale(0.9);
      }
    }
  }
</style>
